/* eslint-disable eqeqeq */
import React, { useEffect, useState } from 'react';
import useLocales from 'src/hooks/useLocales';
import Loader from 'src/components/loader/Loader';
import { AttendanceReportResult, EmployeeDetail } from 'src/@types/attendanceReport';
import { IContractInfo } from 'src/@types/Choqorak/MainTables/Contract/ContractInfo';
import { IRentPayment } from 'src/@types/Choqorak/MainTables/RentPayment.ts/RentPayment';
import { GetMonthName } from 'src/sections/common/GetMonthName';

type Props = {
  Report: IRentPayment[];
};

export default function ContractReportPDF({ Report }: Props) {
  const recordsPerPage = 36;
  const { translate } = useLocales();
  const [dirction, setDirection] = useState('ltr');
  const [department, setDepartment] = useState('');
  const [id, setId] = useState('');
  const [name, setName] = useState('');
  const [position, setPosition] = useState('');
  const [startDate, setStartDate] = useState<Date>();
  // const [endDate, setEndDate] = useState<Date>();
  const [endDate, setEndDate] = useState<Date>();
  const lang = localStorage.getItem('i18nextLng');

  useEffect(() => {
    if (lang === 'ps' || lang === 'dr') {
      setDirection('rtl');
    } else {
      setDirection('ltr');
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dirction]);

  if (Report!.length === 0) {
    return <Loader />;
  }

  const thStyle = `table-th-Attandence-Report text-[12px]`;

  const tdStyle = `table-td-Attandence-Report text-[11px]`;

  const width = 'w-[240mm]';

  const totalPages = Math.ceil(Report!.length / recordsPerPage);

  const formatDate = (dateString: any) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US');
  };

  // Create a new Date object
  const currentDate = new Date();

  // Specify Afghanistan's timezone offset
  const timezoneOffset = 4.5 * 60 * 60 * 1000; // Offset in milliseconds (4.5 hours ahead of UTC)

  // Adjust the date to Afghanistan's timezone
  const afghanistanTime = new Date(currentDate.getTime() + timezoneOffset);

  // Format the date as desired
  const formattedDate = afghanistanTime.toLocaleString('en-US', {
    timeZone: 'Asia/Kabul', // Specify Afghanistan's timezone
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: true,
  });

  return (
    <>
      <div className="px-7">
        {Report!.length > 0 ? (
          <div className={`${width} h-[297mm] mx-auto  bg-white text-black`} dir={`${dirction}`}>
            {Array.from({ length: totalPages }).map((_, pageIndex) => (
              <div key={pageIndex} className="page-break py-5 px-2">
                <div className="border-[2px] border-black border-b-0 pt-4 pb-2">
                  <div className="flex justify-between items-center px-5">
                    {/* Left Logo */}
                    <div className="flex flex-col justify-center items-center text-center">
                      <img
                        src={require('src/assets/Choqorak/logo1.png')}
                        width="100"
                        height="100"
                        alt="logo1"
                      />
                    </div>

                    {/* Center Text */}
                    <div className="text-base text-center font-bold print:text-base">
                      <h3>چقرک مرکز پخش مواد خوراکی</h3>
                      {/* <h3>گزارش قرارداد ها</h3> */}
                    </div>

                    {/* Right Logo */}
                    <div className="flex flex-col justify-center items-center text-center">
                      <img
                        src={require('src/assets/Choqorak/logo2.png')}
                        width="200"
                        height="400"
                        alt="logo2"
                      />
                    </div>
                  </div>

                  {/* {Report && (
                    <div className=" border-t-2 border-black mt-2">
                      <div className="flex justify-between items-center pt-2 text-sm px-5">
                        <p>
                          {translate('AttandenceReport.ID')} : {id}
                        </p>
                        <p>
                          {' '}
                          {translate('AttandenceReport.Name')} : {name}
                        </p>
                        <p>
                          {' '}
                          {translate('AttandenceReport.Directorate')} : {department}
                        </p>
                        <p>
                          {' '}
                          {translate('AttandenceReport.Position')} : {position}
                        </p>
                        <div className="flex justify-start items-center px-2" dir={dirction}>
                          {lang == 'en' ? (
                            <>
                              <p className="px-1"> {translate('AttandenceReport.Date')} : </p>
                              <p>
                                <span> {translate('AttandenceReport.From')} </span>
                                {formatDate(startDate)}
                              </p>
                              <p>
                                <span className="px-1"> {translate('AttandenceReport.To')}</span>{' '}
                                {formatDate(endDate)}
                              </p>
                            </>
                          ) : (
                            <>
                              <p className="px-1"> {translate('AttandenceReport.Date')} : </p>
                              <p>
                                <span> {translate('AttandenceReport.From')} </span>
                                {formatDate(startDate)}
                              </p>
                              <p>
                                <span className="px-1"> {translate('AttandenceReport.To')}</span>{' '}
                                {formatDate(endDate)}
                              </p>
                            </>
                          )}
                        </div>
                      </div>
                    </div>
                  )} */}
                </div>

                <div>
                  <table className="table-style print:text-black">
                    <thead className=" bg-gray-600">
                      <tr className="w-full bg-gray-600 print:bg-gray-600">
                        <th scope="col" className={` ${thStyle}`}>
                          {translate('RentPaymentPrint.No')}
                        </th>
                        <th scope="col" className={` ${thStyle}`}>
                          {translate('RentPaymentPrint.Year')}
                        </th>
                        <th scope="col" className={` ${thStyle}`}>
                          {translate('RentPaymentPrint.Month')}
                        </th>
                        <th scope="col" className={` ${thStyle}`}>
                          {translate('RentPaymentPrint.ContractNumber')}
                        </th>
                        <th scope="col" className={` ${thStyle}`}>
                          {translate('RentPaymentPrint.CustomerName')}
                        </th>
                        <th scope="col" className={` ${thStyle}`}>
                          {translate('RentPaymentPrint.CustomerPhone')}
                        </th>
                        <th scope="col" className={` ${thStyle}`}>
                          {translate('RentPaymentPrint.ShopCode')}
                        </th>
                        <th scope="col" className={` ${thStyle}`}>
                          {translate('RentPaymentPrint.PaymentAmount')}
                        </th>
                        <th scope="col" className={` ${thStyle}`}>
                          {translate('RentPaymentPrint.PaidAmount')}
                        </th>
                        <th scope="col" className={` ${thStyle}`}>
                          {translate('RentPaymentPrint.RemainAmount')}
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {Report!
                        .slice(pageIndex * recordsPerPage, (pageIndex + 1) * recordsPerPage)
                        .map((record: any, index: number) => (
                          <tr
                            className={
                              record.absentOnly == 'Absent'
                                ? 'bg-red-200'
                                : record.holiday == 'Holiday'
                                  ? 'bg-gray-300'
                                  : 'bg-white'
                            }
                            key={index}
                            style={{ pageBreakInside: 'avoid' }}
                          >
                            <td className={`${tdStyle}`}>{pageIndex * recordsPerPage + index + 1}</td>
                            <td className={`${tdStyle}`}>{record.year}</td>
                            <td className={`${tdStyle}`}>{GetMonthName(record.month)}</td>
                            <td className={`${tdStyle}`}>{record.contractNumber}</td>
                            <td className={`${tdStyle}`}>{record.customerName}</td>
                            <td className={`${tdStyle}`}>{record.customerPhone}</td>
                            <td className={`${tdStyle}`}>{record.shopCode}</td>
                            <td className={`${tdStyle}`}>{record.paymentAmount}</td>
                            <td className={`${tdStyle}`}>{record.paidAmount}</td>
                            <td className={`${tdStyle}`}>{record.remainAmount}</td>
                          </tr>
                        ))}
                    </tbody>
                  </table>
                </div>
                {/* <div
                  className={`absolute bottom-5 w-[230mm] mx-auto border-t-2 border-black text-[8pt]`}
                >
                  <div className="px-5 relative w-full mx-auto" dir="ltr">
                    <div className="flex justify-center items-center w-full">
                      <img
                        src={require('src/assets/Choqorak/footer.png')}
                        width="500"
                        height="50"
                        alt="logo2"
                      />
                    </div>
                  </div>
                </div> */}
              </div>
            ))}
          </div>
        ) : (
          <div className="flex justify-center items-center">
            {translate('ReceptionDashboard.NoRecordFound')}
          </div>
        )}
      </div>
    </>
  );
}
